// extracted by mini-css-extract-plugin
export default {"section":"components-ArticleSection-articleSection__section--iiJER","gridStyling":"components-ArticleSection-articleSection__gridStyling--VMQmn"};